// extracted by mini-css-extract-plugin
export var container = "footer-module--container--8eueV";